.upload {
  display: block;
  width: 100%;

  :global {
    .ant-upload {
      display: block;
    }
  }

  &__button {
    display: flex;
    justify-content: center;
    padding: 14px;
    border: 1px dashed var(--x-color-action);
    border-radius: 4px;
    background-color: var(--x-color-background-accent-lighter);
    color: var(--x-color-text-accent);
    cursor: pointer;
    transition: background-color 0.1s;

    &:hover:not(&_disabled) {
      background-color: var(--x-color-background-accent);
    }

    &_small {
      padding: 4px;
      font-size: 12px;
    }

    &_medium {
      min-height: 52px;
      padding: 14px;
    }

    &_disabled {
      border-color: var(--x-color-border);
      background-color: var(--x-color-background-lighter);
      color: var(--x-color-text-primary-disabled);
      cursor: default;
    }
  }

  &__buttonLabel {
    display: flex;
    align-items: center;

    svg {
      margin-right: 5px;
    }
  }
}

.spin {
  height: 20px;
}
